import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { PopUp } from '../../../models/popup.model';
import { StorageProvider } from '../../../services/storage.provider';
import { Multitenant } from '../../../services/multitenant.provider';

@Component({
  selector: 'app-pop-up',
  templateUrl: 'pop-up.html',
  styleUrls: ['pop-up.scss']
})
export class PopUpComponent {
  @Input() public show = false;
  @Input() public data: PopUp;
  @Output() public popUpNotify: EventEmitter<string> = new EventEmitter<string>();
  public video: boolean;
  private themeClass: string;

  constructor(private storage: StorageProvider, private multitenant: Multitenant, private router: Router ) {
    this.themeClass = this.multitenant.getDomainClass();
  }

  closeTooltip() {
    this.show = false;
    this.popUpNotify.emit('closed');
    this.storage.setSessionStorage('hybridApp', 'shown');
  }

  closeAndConfirm() {
    this.show = false;
    this.popUpNotify.emit('confirm');
    if (this.data.data && this.data.type === 'menuPlatformLinks') {
      window.open(this.data.data, '_blank');
    }
    if (this.data.data && this.data.type === 'noAccess') {
      this.router.navigate(['/editer-profil'], { queryParams: { profile: JSON.stringify(this.data.data) } });
    }
  }

  closeAndStamp() {
    this.closeAndConfirm();
    this.setTimeStamp();
  }

  goToOffers() {
    if (this.themeClass === 'week') {
      window.open('https://www.playbacpresse.fr/abonnements-my-weekly', '_blank');
    } else if (this.themeClass === 'sema') {
      window.open('https://www.playbacpresse.fr/abonnements-mi-semanal', '_blank');
    } else if (this.themeClass === 'woch') {
      window.open('https://www.playbacpresse.fr/abonnements-meine-woche', '_blank');
    } else if (this.themeClass === 'mlwk') {
      window.open('https://www.playbacpresse.fr/abonnements-my-little-weekly', '_blank');
    } else if (this.themeClass === 'lepq') {
      window.open('https://www.playbacpresse.fr/abonnements-le-petit-quotidien', '_blank');
    } else if (this.themeClass === 'mquo') {
      window.open('https://www.playbacpresse.fr/abonnements-mon-quotidien', '_blank');
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else if (this.themeClass === 'mwjp') {
      window.open('https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank');
    } else if (this.themeClass === 'mwde') {
      window.open('https://go.playbacpresse.fr/myweekly-german_2019.html', '_blank');
    } else if (this.themeClass === 'mljp') {
      window.open('https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank');
    } else if (this.themeClass === 'mlde') {
      window.open('https://go.playbacpresse.fr/mylittleweekly-german_2019.html', '_blank');
    } else {
      window.open('https://www.playbacpresse.fr', '_blank');
    }
  }

  openStore() {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    const isAndroid = !iOSSafari && navigator.userAgent.match(/android/i) != null;

    if (iOSSafari) {
      if (this.themeClass === 'week') {
        window.open('http://itunes.apple.com/app/id417965901', '_self');
      } else if (this.themeClass === 'sema') {
        window.open('http://itunes.apple.com/app/id954575601', '_self');
      } else if (this.themeClass === 'woch') {
        window.open('http://itunes.apple.com/app/id823693848', '_self');
      } else if (this.themeClass === 'mlwk') {
        window.open('http://itunes.apple.com/app/id417965355', '_self');
      } else if (this.themeClass === 'lepq') {
        window.open('http://itunes.apple.com/app/id425160827', '_self');
      } else if (this.themeClass === 'mquo') {
        window.open('http://itunes.apple.com/app/id425160827', '_self');
      } else if (this.themeClass === 'actu') {
        window.open('http://itunes.apple.com/app/id1420135923', '_self');
      } else if (this.themeClass === 'aeco') {
        window.open('http://itunes.apple.com/app/id440265600', '_self');
      } else if (this.themeClass === 'mquovideo') {
        window.open('http://itunes.apple.com/app/id1186323169', '_self');
      } else {
        window.open('http://itunes.apple.com/app/id1186323169', '_self');
      }
    }

    if (isAndroid) {
      window.open(
        `intent://home#Intent;package=com.playbac.${this.themeClass};scheme=playbac${this.themeClass};launchFlags=268435456;end;`,
        '_self'
      );
    }
  }

  closeAndRedirect(page) {
    this.closeAndConfirm();
    if ((page === 'login' || page === 'create') && localStorage.getItem('uit')) {
      localStorage.removeItem('uit');
    }

    if (page === 'login') {
      this.router.navigate(['/connexion']);
    }

    if (page === 'create' && this.themeClass === 'playbacpresse') {
      this.router.navigate(['creer-compte', 'etape-1']);
    } else if (page === 'create' && this.themeClass !== 'playbacpresse') {
      window.open('https://m-digital.playbacpresse.fr/creer-compte/etape-1', '_blank');
    }
  }

  setTimeStamp() {
    if (this.data.type === 'unIdentifiedUser') {
      const now = Date.now().toString();
      localStorage.setItem('uit', now);
    }
  }
}
